<template>
  <div class="page-bottom">
    <img src="~@/assets/images/page-bottom.png" />
  </div>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.page-bottom {
  position: absolute;
  text-align: center;
  // bottom: 2.7037rem;
  bottom: 0.7037rem;
  left: 0;
  right: 0;
  z-index: 2;
  transform-style: preserve-3d;

  transform: translateZ(0);
  img {
    width: 4.0741rem;
    height: 6.4815rem;

    transform: translateZ(0);

    animation: bottom-keyframes 3.6s infinite ease-out;
    @keyframes bottom-keyframes {
      0% {
        transform: translateY(0) translateZ(0);
        opacity: 1;
      }
      50% {
        transform: translateY(-3rem) translateZ(0);
        opacity: 1;
      }
      100% {
        transform: translateY(-3rem) translateZ(0);
        opacity: 0;
      }
    }
  }
}
</style>